"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Chain

exports.V1_GET_INFO = "/v1/chain/get_info";
exports.V1_GET_TABLE_ROWS = "/v1/chain/get_table_rows";
exports.V1_GET_TABLE_BY_SCOPE = "/v1/chain/get_table_by_scope";
exports.V1_GET_CURRENCY_STATS = "/v1/chain/get_currency_stats";
exports.V1_GET_CURRENCY_BALANCE = "/v1/chain/get_currency_balance"; // DSP

exports.V1_DSP_GET_TABLE_ROW = "/v1/dsp/ipfsservice1/get_table_row";